import { Box, IconButton } from "@mui/joy";
import discordIcon from "../icons/discord.svg";
import facebookIcon from "../icons/facebook.svg";

interface SocialMediaIconsProps {
  size?: number;
  gap?: number;
  mr?: number;
}

export function SocialMediaIcons({
  size = 32,
  gap = 1,
  mr = 1,
}: SocialMediaIconsProps): JSX.Element {
  return (
    <Box sx={{ display: "flex", gap, mr }}>
      <IconButton
        size="sm"
        variant="plain"
        color="neutral"
        component="a"
        href="https://discord.gg/HhqnAp3uJ2"
        target="_blank"
        rel="noopener noreferrer nofollow"
        sx={{
          p: 0.5,
          "&:hover": {
            transform: "scale(1.1)",
            transition: "transform 0.2s",
          },
        }}
      >
        <img
          src={discordIcon}
          alt="Discord"
          style={{ width: size, height: size }}
        />
      </IconButton>
      <IconButton
        size="sm"
        variant="plain"
        color="neutral"
        component="a"
        href="https://www.facebook.com/profile.php?id=61574297432813"
        target="_blank"
        rel="noopener noreferrer nofollow"
        sx={{
          p: 0.5,
          "&:hover": {
            transform: "scale(1.1)",
            transition: "transform 0.2s",
          },
        }}
      >
        <img
          src={facebookIcon}
          alt="Facebook"
          style={{ width: size, height: size }}
        />
      </IconButton>
    </Box>
  );
}
